import { useSnackbarStore } from '@/stores/snackbarStore.ts';
import ResponseConstant from '@/constants/responseConstant.ts';
import i18n from '@/plugins/i18n/config.ts'

import type { AxiosError } from 'axios';
import type { ApiError } from '@/types/services/utils/axios.type.ts';

export const displayToast = (message: string, color: string): void => {
  useSnackbarStore().openSnackbar({text: message, color: color})
}

export const displayResponseError = (error: AxiosError<ApiError> | null, toast_type = 'error'): void => {
  if (error && error.response?.data) {
    const api_error: ApiError = error.response?.data;

    // Request validation error (`{detail, errors: [...]}`, no `key`): generic message.
    if (error.response.status === 422 && !api_error.key) {
      displayToast(i18n.global.t('apiResponse.validationError'), toast_type)
    } else if (api_error.key in ResponseConstant) {
      const {key} = api_error;
      displayToast(i18n.global.t('apiResponse.' + ResponseConstant[key]), toast_type)
    } else {
      displayToast(i18n.global.t('apiResponse.unknown'), toast_type)
    }

  } else {
    displayToast(i18n.global.t('apiResponse.unknown'), toast_type)
  }
}

